export const dangerIconStyle = {
  width: "42",
  height: "36px",
    
  background: "rgba(255,0,0,0.12)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: "red",
  cursor: "pointer",
};
